import React from 'react'
import ReactDOM from 'react-dom'
import RoomPageBase from './room-page-base'
import moment from 'lib/moment-timezone-custom'
import Glide, { Controls, Autoplay, Images, Swipe, Breakpoints, Lazy, GLIDE_SETTINGS } from 'frontend/lib/glide/bundle'
import clickToPlayWrap from 'lib/click-to-play-wrap'
import Reviews from 'frontend/pages/rooms/reviews'

export default class RoomPage extends RoomPageBase {
  static initMediaSlider () {
    const slidesCount = document.querySelectorAll('.media_slider .slider__slide').length

    if (slidesCount <= 1) {
      console.log('RoomPage.initMediaSlider(): skipped because to few slides:', slidesCount)
      return
    }

    new Glide('.media_slider',
      Object.assign(
        GLIDE_SETTINGS,
        {
          autoplay: 6000,
          hoverstop: true,
        },
      ),
    ).mount({ Swipe, Images, Controls, Autoplay, Lazy })
    document.querySelectorAll('.media_slider .video').forEach(el => clickToPlayWrap(el))
  }

  static async importSchedule () {
    let imported

    if (this.props.online === 'true') {
      imported = await import('frontend/pages/rooms/online-room-schedule')
    } else {
      imported = await import('frontend/schedule/room-schedule')
    }

    return imported.default
  }

  static async mountRoomSchedule () {
    if (this.roomScheduleMounted || !this.scheduleRoot) return

    this.roomScheduleMounted = true
    const scheduleComponent = await this.importSchedule()

    ReactDOM.render(
      React.createElement(
        scheduleComponent,
        {
          roomId: parseInt(this.props.roomId),
          openedFrom: moment(this.props.openedFrom),
          prebookingCodeOnly: this.props.prebookingCodeOnly !== undefined,
        },
      ),
      this.scheduleRoot,
    )
  }

  static initOtherGamesSlider () {
    new Glide('.other_games .rooms_list',
      Object.assign(
        GLIDE_SETTINGS,
        {
          perView: 4,
          breakpoints: {
            425: { perView: 1 },
            768: { perView: 2 },
            1280: { perView: 3 },
          },
        },
      ),
    ).mount({ Swipe, Images, Controls, Breakpoints })
  }

  static handleStylesApplied () {
    this.initMediaSlider()
    Reviews.init()
    this.onEnter('.schedule_place', () => { this.mountRoomSchedule() })
    setTimeout(() => { this.mountRoomSchedule() }, this.scheduleFallbackDelay)
    this.onEnter('.other_games .rooms_list', this.initOtherGamesSlider.bind(this))
  }

  static get props () {
    return document.body.dataset
  }
}

RoomPage.init()
